import React, { useEffect, useState } from 'react';
import './CookieBanner.css';

const translations = {
  fr: {
    text: "Ce site utilise uniquement des cookies nécessaires à son fonctionnement. Aucun cookie tiers n’est utilisé. En poursuivant, vous acceptez ces cookies.",
    button: "OK"
  },
  en: {
    text: "This site only uses cookies necessary for its operation. No third-party cookies are used. By continuing, you accept these cookies.",
    button: "OK"
  },
  de: {
    text: "Diese Website verwendet nur Cookies, die für ihren Betrieb erforderlich sind. Es werden keine Drittanbieter-Cookies verwendet. Durch die weitere Nutzung akzeptieren Sie diese Cookies.",
    button: "OK"
  },
  it: {
    text: "Questo sito utilizza solo i cookie necessari al suo funzionamento. Non vengono utilizzati cookie di terze parti. Continuando, accetti questi cookie.",
    button: "OK"
  },
  es: {
    text: "Este sitio solo utiliza cookies necesarias para su funcionamiento. No se utilizan cookies de terceros. Al continuar, acepta estas cookies.",
    button: "OK"
  },
  ja: {
    text: "本サイトは、動作に必要なクッキーのみを使用しています。サードパーティのクッキーは使用していません。続行することで、これらのクッキーに同意したことになります。",
    button: "OK"
  },
  zh: {
    text: "本网站仅使用其运行所需的 Cookie。不使用第三方 Cookie。继续浏览即表示您接受这些 Cookie。",
    button: "OK"
  }
};

function getLang() {
  const lang = navigator.language || navigator.userLanguage || 'en';
  const code = lang.split('-')[0].toLowerCase();
  if (translations[code]) return code;
  return 'en';
}

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const accepted = localStorage.getItem('cookieAccepted');
    if (!accepted) setVisible(true);
    setLang(getLang());
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieAccepted', 'true');
    setVisible(false);
  };

  if (!visible) return null;
  const t = translations[lang] || translations['en'];

  return (
    <div className="cookie-banner">
      <span>
        {t.text}
      </span>
      <button onClick={acceptCookies}>{t.button}</button>
    </div>
  );
};

export default CookieBanner;
